import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import "../App.css"; // Ensure this CSS file exists
import logo from "../assets/logo.png"; // Ensure logo path is correct

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    const normalizedEmail = email.trim().toLowerCase();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(normalizedEmail)) {
      setError("Please enter a valid email address.");
      return;
    }

    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, normalizedEmail);
      setSuccess("Password reset email sent. Please check your inbox.");
    } catch (resetError) {
      let message = "Unable to send reset email. Please try again.";
      switch (resetError.code) {
        case "auth/invalid-email":
          message = "Invalid email address.";
          break;
        case "auth/user-not-found":
          message = "No account found with this email.";
          break;
        case "auth/network-request-failed":
          message = "Network error. Please check your connection.";
          break;
        default:
          message = "Unable to send reset email right now. Please try again.";
      }
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <img src={logo} alt="Timely Logo" className="logo-image" />
        <h1 className="tagline">Smart Appointments</h1>
        <p className="sub-tagline">Wait on your own terms.</p>

        <h2 className="forgot-password-title">Forgot Password</h2>
        <p className="forgot-password-text">
          Please enter your email address. You will receive a link to create a new password via email.
        </p>
        {error && (
          <div className="error-message" style={{ color: "#d32f2f", marginBottom: "12px" }}>
            {error}
          </div>
        )}
        {success && (
          <div style={{ color: "#2e7d32", marginBottom: "12px" }}>
            {success}
          </div>
        )}

        <form className="forgot-password-form" onSubmit={handleSubmit}>
          <label className="input-label">Email</label>
          <input
            type="email"
            className="forgot-password-input"
            placeholder="Enter your email"
            required
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (error) setError("");
              if (success) setSuccess("");
            }}
          />

          <button type="submit" className="forgot-password-btn" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        <p className="remember-password">
          Remember your password?{" "}
          <a href="/login" className="sign-in-link">Sign in</a>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
